import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Container, Col, TabContent, TabPane, Nav, NavItem, NavLink, Button } from "reactstrap";
import UserRegistration from './UserRegistration';
import { Loader } from '../common/Loader';
import { CONSTANT } from '../../helper/AllConastant';
import { getLeftMenu, } from '../../actions/auth/AuthActions';
import { reactLocalStorage } from 'reactjs-localstorage';
import { loggedInUserId } from '../../helper/auth';
import { USER, ROLE, DEPARTMENT, LEVELS } from '../../config/constants';
import classnames from 'classnames';
import DepartmentsListing from './DepartmentsListing';
import UsersListing from './UsersListing';

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      activeTab: '1',
      isUserForm: false,
      isRolePermissionForm: false,
      data: {},
      ViewUserAccessibility: false,
      ViewRoleAccessibility: false,
      ViewDepartmentAccessibility: false,
      ViewLevelAccessibility: false,
    }
  }

  /**
  * @method toggle
  * @description toggling the tabs
  */
  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  displayForm = () => {
    this.setState({ isUserForm: true, isRolePermissionForm: false, })
  }

  displayRoleForm = () => {
    this.setState({ isRolePermissionForm: true, isUserForm: false, data: {}, })
  }

  hideForm = () => {
    this.setState({ isUserForm: false, isRolePermissionForm: false, data: {} })
  }

  getUserDetail = (data) => {
    this.setState({ isUserForm: true, isRolePermissionForm: false, data: data })
  }

  getRoleDetail = (data) => {
    this.setState({ isRolePermissionForm: true, isUserForm: false, data: data })
  }

  /**
  * @method render
  * @description Renders the component
  */
  render() {
    const { isUserForm, isRolePermissionForm, data } = this.state;

    if (isUserForm === true) {
      return <UserRegistration
        data={data}
        hideForm={this.hideForm}
      />
    }

    return (
      <Container fluid className="user-page cr-table-wrap">
        {/* {this.props.loading && <Loader/>} */}
        <div>
          <Row>
            <Col md="6" className="form-heading">
              <h2>User Management</h2>
            </Col>
          </Row>
          <Nav tabs className="subtabs">
            <NavItem>
              <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggle('1'); }}>
                Manage Users
              </NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink className={classnames({ active: this.state.activeTab === '3' })} onClick={() => { this.toggle('3'); }}>
                Manage Department
              </NavLink>
            </NavItem> */}
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            {this.state.activeTab === '1' &&
              <TabPane tabId="1">
                <UsersListing
                  formToggle={this.displayForm}
                  getUserDetail={this.getUserDetail}
                />
              </TabPane>}
            {this.state.activeTab === '3' &&
              <TabPane tabId="3">
                <DepartmentsListing
                  toggle={this.toggle} />
              </TabPane>}
          </TabContent>
        </div>
      </Container >
    );
  }
}

/**
* @method mapStateToProps
* @description return state to component as props
* @param {*} state
*/
function mapStateToProps({ auth }) {
  const { leftMenuData, loading } = auth;

  return { leftMenuData, loading };
}


export default connect(mapStateToProps,
  {
    getLeftMenu
  }
)(User);

